import { motion } from 'framer-motion';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import Header from '../../../components/Header/Header';
import MessageBox from '../../../components/MessageBox/MessageBox';
import RowItemView from '../../../components/RowItem';
import { Env } from '../../../env';
import useRootStore from '../../../hooks/useRootStore';
import { InputComponent } from '../../../utils/inputComponent';
import styles from './AddFriend.module.css';

const container = {
    hidden: { opacity: 1, scale: 0 },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            delayChildren: 0.08,
            staggerChildren: 0.1,
        },
    },
};

const item = {
    hidden: { y: 20, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1,
    },
};

const AddFriend = () => {
    const { t } = useTranslation();
    const { filteredNonFriends, getUsersFilter, clearNonFriends } = useRootStore().usersStore;
    const { getFriendDetails } = useRootStore().usersStore;

    const { createFriend } = useRootStore().friendsStore;
    const { closeModal, toRouter } = useRootStore().routerStore;

    const handleChangeText = (text: string) => {
        getUsersFilter(text);
    };

    const FriendDetails = (friendId: number) => {
        getFriendDetails(friendId);
        toRouter('friendDetails');
    };

    const onbackHandle = () => {
        closeModal('left');
        clearNonFriends();
    };

    return (
        <div className={styles.container}>
            <Header
                style={{ zIndex: 1000 }}
                text={t('nonFriend')}
                leftIcon="arrowLeft"
                onLeftIconPress={onbackHandle}
            />
            <div style={{ width: '90%', margin: '3px auto' }}>
                <InputComponent onChangeText={handleChangeText} placeholder="Search..." />
            </div>
            <div className={styles.main}>
                {!filteredNonFriends && (
                    <div className={styles.loadingError}>
                        <MessageBox title={`${t('No Internet Connection')}`} />
                    </div>
                )}
                <motion.div variants={container} initial="hidden" animate="visible" className={styles.contentBox}>
                    {filteredNonFriends?.length !== 0 ? (
                        filteredNonFriends?.map((e, index) => {
                            return (
                                <motion.div variants={item} key={index} id="map-dev" className={styles.channelRowBox}>
                                    <RowItemView
                                        title={`${t('add')}`}
                                        imageUrl={e.avatar ? `${Env.AssetsUrl}/${e.avatar}` : ''}
                                        color={e.color}
                                        text={e.username}
                                        loading={false}
                                        onPressComponent={() => FriendDetails(e.id ? e.id : 0)}
                                        onButtonPress={() => createFriend(e.id ? e.id : 0)}
                                        rightButton
                                        leng={19}
                                    />
                                </motion.div>
                            );
                        })
                    ) : (
                        <MessageBox title="Search by username" />
                    )}
                </motion.div>
            </div>
        </div>
    );
};

export default observer(AddFriend);
